<template>
  <div class="map-root select-none">
    <div ref="map-mapview" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "UMap",
  controller: "Home",
  action: "UMap",
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    query: {
      syscode: {
        type: String,
        required: true,
        default: "ZJMap",
      },
      ukey: {
        type: String,
        required: true,
        default: "DefaultMap",
      },
    },
  },
  data() {
    return {
      loadingText: "加载中...",
      mapInstance: null,
      syscode:"",
      ukey:""
    };
  },
  methods: {
    layerButtonClick: function (data) {
      this.$emit("layerButtonClick", data);
    },
    loadMap(){
      // 创建地图，并通过样式让地图填满窗口
    let that = this;
    let syscode = this.syscode || "ZJMap";
    let ukey = this.ukey || "DefaultMap";

    this.$nextTick(function () {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-mapview"]).zjumap({
        syscode: syscode,
        key: ukey,
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        // eslint-disable-next-line no-undef
        mapConfigs: $.extend(
          {},
          {
            onMapCreated: function (e) {
              that.mapInstance = e.map;
              that.center = e.map.config.center;
              //that.addDom();
            },
            onLayerButtonClick: function (e) {
              var item = e.originEvent.currentTarget;
              // eslint-disable-next-line no-undef
              var action = $(item).data("action");
              var data = {
                e: e,
                action: action,
              };
              that.layerButtonClick(data);
            },
          }
        ),
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
    }
  },
  created() {
    console.debug("mapview created");
  },
  mounted() {
    this.loadMap();
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {},
  watch: {
    query: {
      handler: function (val, oldVal) {
        console.log(val, oldVal);
        this.syscode = val.syscode;
        this.ukey = val.ukey;
        this.loadMap();
      },
      deep: true,
      immediate: true,
    },
  }
};
</script>

<style scoped>
.map {
  border-radius: 20px;
}
</style>